"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleLineContentFragment = void 0;
exports.singleLineContentFragment = `
fragment singleLineContent on SingleLineContent {
  text
}
`;
//# sourceMappingURL=single-line-content.js.map